import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AiPrompt, AiPromptUsage} from 'app/Model/aiprompt';
import {InvoiceSettingDto} from 'app/Model/Dto/InvoiceSettingDto';
import {AiPromptsService} from 'app/Services/aiprompt.service';
import {InvoiceService} from 'app/Services/invoice.service';
import {LoginService} from 'app/Services/login.service';
import {SystemService} from 'app/Services/system.service';
import {TemplateService} from 'app/Services/template.service';
import {lastValueFrom} from 'rxjs';


@Component({
    selector: 'description-wizard',
    templateUrl: './description-wizard.component.html',
    standalone: false
})
export class DescriptionWizardComponent implements OnInit {
  @Input() prompt: AiPrompt;
  private systemProvidedProviders: string[] = [];
  @Output() promptChange = new EventEmitter<AiPrompt>();

  prompts: AiPrompt[] = [];

  promptResult: string = null;
  editorVisible = false;
  loading = false;

  invoiceSetting: InvoiceSettingDto = new InvoiceSettingDto();

  constructor(
    public loginService: LoginService,
    public promptService: AiPromptsService,
    public systemService: SystemService,
    public templateService: TemplateService,
    public invoiceServce: InvoiceService
  ) {
  }

  async ngOnInit() {
    this.promptService.getAllForSpecificType(this.loginService.currentCustomer.id, AiPromptUsage.ProductLayer).then(x => {
      this.prompts = x;
    });
    lastValueFrom(this.invoiceServce.GetInvoiceSetting(this.loginService.currentCustomer.id)).then(x => this.invoiceSetting = x);

    this.promptService.getModels(this.loginService.currentCustomer.id).then(models => {
      this.systemProvidedProviders = models.filter(x => x.isSystemProvided).map(x => x.provider);
    });
  }

  public get billedByNextPim(): boolean {
    return !this.prompt?.provider || this.systemProvidedProviders.includes(this.prompt.provider);
  }


  openEditor() {
    this.editorVisible = true;
  }

  async deleteConfig() {
    await this.promptService.delete(this.prompt.id, this.loginService.currentCustomer.id);
    this.prompts = await this.promptService.getAllForSpecificType(this.loginService.currentCustomer.id,AiPromptUsage.ProductLayer);
  }

  async openCreate() {
    let newPrompt = await this.promptService.create(
      new AiPrompt(null, 'Neuer Prompt'),
      this.loginService.currentCustomer.id
    );
    this.prompts = await this.promptService.getAllForSpecificType(this.loginService.currentCustomer.id,AiPromptUsage.ProductLayer);
    this.openEditor();
  }

  onSaveEdit = async () => {
    if (!this.prompt) return;

    if(this.prompt.nextPimTargetFields.length > 0) {      
      this.prompt.nextPimTargetFields = this.prompt.nextPimTargetFields.filter(
        f=> f.field != null
      )
    }
    try {
      await this.promptService.update(this.prompt, this.loginService.currentCustomer.id);
      this.prompts = await this.promptService.getAllForSpecificType(this.loginService.currentCustomer.id,AiPromptUsage.ProductLayer);
    } catch (err) {
      console.error(err);
    }
    this.editorVisible = false;
  };

  onCancelEdit = () => {
    this.editorVisible = false;
  };

  selectedPromptChanged() {
    this.promptChange.emit(this.prompt);
  }
}
